import { render, staticRenderFns } from "./status-progress.vue?vue&type=template&id=520f33b9&scoped=true"
import script from "./status-progress.vue?vue&type=script&lang=js"
export * from "./status-progress.vue?vue&type=script&lang=js"
import style0 from "./status-progress.vue?vue&type=style&index=0&id=520f33b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f33b9",
  null
  
)

export default component.exports